export default function buildFilter(filters) {
  let activeFilters = [];

  for (const filter in filters.bool) {
    if (filters.bool.hasOwnProperty(filter) && filters.bool[filter]) {
      activeFilters.push(filter);
    }
  }

  if (filters.eliteReferrer) {
    activeFilters.push('referrer.elite');
  }

  if (filters.referral) {
    activeFilters.push('referral');
  }

  if (filters.notReferral) {
    activeFilters.push('!referral');
  }

  if (filters.questionsComplete) {
    activeFilters.push('questions_complete');
  }

  if (filters.questionsIncomplete) {
    activeFilters.push('!questions_complete');
  }

  if (filters.registered) {
    activeFilters.push('is_registered');
  }

  if (filters.notRegistered) {
    activeFilters.push('!is_registered');
  }

  if (filters.noEmail) {
    activeFilters.push('noEmail');
  }
  if (filters.withEmail) {
    activeFilters.push('!noEmail');
  }

  if (filters.closed) {
    activeFilters.push('!open');
  }

  if (filters.open) {
    activeFilters.push('open');
  }

  if (filters.autoSendEnquiries) {
    activeFilters.push('customer.auto_send_enquiries');
  }

  if (filters.noEnquiries) {
    activeFilters.push('!has_enquiries');
  }

  if (filters.ownerNotAssigned) {
    activeFilters.push('!owner_assigned');
  }

  if (filters.notAutoSendEnquiries) {
    activeFilters.push('!customer.auto_send_enquiries');
  }

  if (filters.withPhone) {
    activeFilters.push('!noPhone');
  }
  if (filters.noPhone) {
    activeFilters.push('noPhone');
  }

  return activeFilters;
}
